import React from 'react';
import { FormattedMessage } from 'react-intl';

export const deliveryTitle = (
    <FormattedMessage id="pdpBlurb.deliveryTitle" defaultMessage="Shipping: " />
);

export const freeShippingTitle = (
    <FormattedMessage id="pdpBlurb.freeShippingTitle" defaultMessage="Free Shipping" />
);

export const freeWhiteGloveShippingTitle = (
    <FormattedMessage
        id="pdpBlurb.freeWhiteGloveShippingTitle"
        defaultMessage="Free White Glove Shipping"
    />
);

export const whiteGloveShippingTitle = price => (
    <FormattedMessage
        id="pdpBlurb.whiteGloveShippingTitle"
        defaultMessage="{price} White Glove Shipping"
        values={{ price }}
    />
);

export const leadTimeTitle = (
    <FormattedMessage id="pdpBlurb.leadTimeTitle" defaultMessage="Estimated Production Time" />
);

export const buyerProtectionTitle = (
    <FormattedMessage
        id="pdpBlurb.buyerProtectionTitle"
        defaultMessage={'Buyer Protection Guarantee'}
    />
);

export const buyerProtectionText = (
    <FormattedMessage
        id="pdpBlurb.buyerProtectionText"
        defaultMessage={`If your purchase doesn't arrive as described, 1stdibs will make it right.`}
    />
);

export const pcsTitle = (
    <FormattedMessage id="pdpBlurb.pcsTitle" defaultMessage="Private Client Service" />
);
export const pcsText = name => (
    <FormattedMessage
        id="pdpBlurb.pcsText"
        defaultMessage={`
            {hasName, select,
                true {Contact your specialist, {name}, for dedicated assistance.}
                false {Contact a specialist for dedicated assistance.}
            }
        `}
        values={{ name, hasName: !!name }}
    />
);

export const returnsTitle = (
    <FormattedMessage id="pdpBlurb.returnsTitle" defaultMessage="Worry-Free Returns" />
);
export const returnsText = returnPolicyLength => (
    <FormattedMessage
        id="pdpBlurb.returnsText"
        defaultMessage={`This piece can be returned within {returnPolicyLength, number} {returnPolicyLength, plural,
            one {day}
            other {days}
        }.`}
        values={{ returnPolicyLength }}
    />
);
export const returnsCta = (
    <FormattedMessage id="pdpBlurb.returnsCta" defaultMessage="View Details" />
);

export const shipsFrom = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.requestQuoteOverviewShipsFrom"
        defaultMessage="Ships From: "
    />
);

export const shipsFromLocation = itemLocation => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.requestQuoteOverviewShipsFromLocation"
        defaultMessage="{itemLocation}"
        values={{ itemLocation }}
    />
);

export const supportNumberTitle = (
    <FormattedMessage id="pdp.PdpSharedBlurbSupportNumber.blurbTitle" defaultMessage="Need help?" />
);

export const supportNumberText = supportNumber => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbSupportNumber.blurbText"
        defaultMessage="Call our 1stdibs specialists {supportNumber}"
        values={{ supportNumber }}
    />
);
